export default {
  components: {}
}
